import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import { ActionInterface } from 'common/action.interface';
import {
  EmployeesTypes,
  EmployeeInterface,
  EmployeeReportInterface,
  AddPaymentInterface,
  EmployeeDailyReportInterface,
  EmployeeSettingsInterface,
  EmployeeRatingInterface,
} from './types';

// List Employees
export const listEmployeesRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(EmployeesTypes.LIST_EMPLOYEES_REQUEST, payload);
export const listEmployeesSuccess = (payload: {
  employeesList: EmployeeInterface[];
  totalCount: number;
}) => action(EmployeesTypes.LIST_EMPLOYEES_SUCCESS, payload);
export const listEmployeesFailure = () =>
  action(EmployeesTypes.LIST_EMPLOYEES_FAILURE);

// List Inactive Employees
export const listInactiveEmployeesRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(EmployeesTypes.LIST_INACTIVE_EMPLOYEES_REQUEST, payload);
export const listInactiveEmployeesSuccess = (payload: {
  inactiveEmployeesList: EmployeeInterface[];
  totalCountInactive: number;
}) => action(EmployeesTypes.LIST_INACTIVE_EMPLOYEES_SUCCESS, payload);
export const listInactiveEmployeesFailure = () =>
  action(EmployeesTypes.LIST_INACTIVE_EMPLOYEES_FAILURE);

// Get Employee
export const getEmployeeRequest = (payload: object) =>
  action(EmployeesTypes.GET_EMPLOYEE_REQUEST, payload);
export const getEmployeeSuccess = (payload: {
  employeeData: EmployeeInterface;
}) => action(EmployeesTypes.GET_EMPLOYEE_SUCCESS, payload);
export const getEmployeeFailure = () =>
  action(EmployeesTypes.GET_EMPLOYEE_FAILURE);

// Get Daily Employee Report
export const getDailyEmployeeRequest = (payload: object) =>
  action(EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_REQUEST, payload);
export const getDailyEmployeeSuccess = (payload: {
  employeesDailyReports: EmployeeDailyReportInterface[];
}) => action(EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_SUCCESS, payload);
export const getDailyEmployeeFailure = () =>
  action(EmployeesTypes.GET_EMPLOYEES_DAILY_REPORT_FAILURE);

// Filter Employees
export const filterEmployeesRequest = (payload: {
  body: object;
  filtering?: boolean;
}) => asyncAction(EmployeesTypes.FILTER_EMPLOYEES_REQUEST, payload);
export const filterEmployeesSuccess = (payload: {
  filterEmployeesList: EmployeeInterface[];
  totalCount: number;
}) => action(EmployeesTypes.FILTER_EMPLOYEES_SUCCESS, payload);
export const filterEmployeesFailure = () =>
  action(EmployeesTypes.FILTER_EMPLOYEES_FAILURE);

// Create Employee
export const createEmployeeRequest = (payload: object, redirectTo: string) =>
  action(EmployeesTypes.CREATE_EMPLOYEE_REQUEST, payload, { redirectTo });
export const createEmployeeSuccess = (payload: {
  employeeData: EmployeeInterface;
}) => action(EmployeesTypes.CREATE_EMPLOYEE_SUCCESS, payload);
export const createEmployeeFailure = () =>
  action(EmployeesTypes.CREATE_EMPLOYEE_FAILURE);

// Update Employee
export const updateEmployeeRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(EmployeesTypes.UPDATE_EMPLOYEE_REQUEST, payload, {
    dispatchOnSuccess,
  });
export const updateEmployeeSuccess = (payload: {
  employeeData: EmployeeInterface;
}) => action(EmployeesTypes.UPDATE_EMPLOYEE_SUCCESS, payload);
export const updateEmployeeFailure = () =>
  action(EmployeesTypes.UPDATE_EMPLOYEE_FAILURE);

// Delete Employee
export const deleteEmployeeRequest = (
  payload: object,
  dispatchOnSuccess?: ActionInterface,
) =>
  action(EmployeesTypes.DELETE_EMPLOYEE_REQUEST, payload, {
    dispatchOnSuccess,
  });
export const deleteEmployeeSuccess = () =>
  action(EmployeesTypes.DELETE_EMPLOYEE_SUCCESS);
export const deleteEmployeeFailure = () =>
  action(EmployeesTypes.DELETE_EMPLOYEE_FAILURE);

export const deleteListEmployeeRequest = (payload: Array<string>) =>
  action(EmployeesTypes.DELETE_LIST_EMPLOYEE_REQUEST, payload);
export const deleteListEmployeeSuccess = () =>
  action(EmployeesTypes.DELETE_LIST_EMPLOYEE_SUCCESS);
export const deleteListEmployeeFailure = () =>
  action(EmployeesTypes.DELETE_LIST_EMPLOYEE_FAILURE);

// Change Password
export const changePasswordRequest = (payload: object) =>
  action(EmployeesTypes.CHANGE_PASSWORD_REQUEST, payload);

export const changePasswordSuccess = () =>
  action(EmployeesTypes.CHANGE_PASSWORD_SUCCESS);

export const changePasswordFailure = () =>
  action(EmployeesTypes.CHANGE_PASSWORD_FAILURE);

// Employee Reports
export const getEmployeesReportRequest = (payload: object) =>
  action(EmployeesTypes.GET_EMPLOYEES_REPORT_REQUEST, payload);

export const getEmployeesReportSuccess = (payload: {
  employeesReports: EmployeeReportInterface;
}) => action(EmployeesTypes.GET_EMPLOYEES_REPORT_SUCCESS, payload);

export const getEmployeesReportFailure = () =>
  action(EmployeesTypes.GET_EMPLOYEES_REPORT_FAILURE);

// Add Employee Payment
export const addEmployeePaymentRequest = (payload: AddPaymentInterface) =>
  action(EmployeesTypes.ADD_EMPLOYEE_PAYMENT_REQUEST, payload);

export const addEmployeePaymentSuccess = () =>
  action(EmployeesTypes.ADD_EMPLOYEE_PAYMENT_SUCCESS);

export const addEmployeePaymentFailure = () =>
  action(EmployeesTypes.ADD_EMPLOYEE_PAYMENT_FAILURE);

// Remove Payment Employee
export const removeEmployeePaymentRequest = (payload: object) =>
  action(EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_REQUEST, payload);

export const removeEmployeePaymentSuccess = () =>
  action(EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_SUCCESS);

export const removeEmployeePaymentFailure = () =>
  action(EmployeesTypes.REMOVE_EMPLOYEE_PAYMENT_FAILURE);

export const setSelectedCollection = (payload: {
  selectedCollection: number | null;
}) => action(EmployeesTypes.SET_SELECTED_COLLECTION, payload);

// Create Many Employee
export const createManyEmployeeRequest = (payload: Array<object>) =>
  action(EmployeesTypes.CREATE_MANY_EMPLOYEE_REQUEST, payload);
export const createManyEmployeeSuccess = (payload: {
  manyEmployeesList: EmployeeInterface[];
}) => action(EmployeesTypes.CREATE_MANY_EMPLOYEE_SUCCESS, payload);
export const createManyEmployeeFailure = () =>
  action(EmployeesTypes.CREATE_MANY_EMPLOYEE_FAILURE);

// Get Employee settings
export const getEmployeeSettingsRequest = (payload: object) =>
  action(EmployeesTypes.GET_EMPLOYEE_SETTINGS_REQUEST, payload);
export const getEmployeeSettingsSuccess = (payload: {
  employeeSettingsData: EmployeeSettingsInterface;
}) => action(EmployeesTypes.GET_EMPLOYEE_SETTINGS_SUCCESS, payload);
export const getEmployeeSettingsFailure = () =>
  action(EmployeesTypes.GET_EMPLOYEE_SETTINGS_FALURE);

// Get Employee settings
export const updateEmployeeSettingsRequest = (payload: object) =>
  action(EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_REQUEST, payload);
export const updateEmployeeSettingsSuccess = (payload: {
  employeeSettingsData: EmployeeSettingsInterface;
}) => action(EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_SUCCESS, payload);
export const updateEmployeeSettingsFailure = () =>
  action(EmployeesTypes.UPDATE_EMPLOYEE_SETTINGS_FALURE);

// Get Employee Restriction List
export const employeeRestrictionListRequest = (payload: object) =>
  asyncAction(EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_REQUEST, payload);
export const employeeRestrictionListSuccess = (payload: {
  employeeRestrictionList: any[];
}) => action(EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_SUCCESS, payload);
export const employeeRestrictionListFailure = () =>
  action(EmployeesTypes.EMPLOYEE_RESTRICTION_LIST_FALURE);

// Get Employee Rating
export const employeeRatingRequest = (payload: object) =>
  asyncAction(EmployeesTypes.EMPLOYEE_RATING_REQUEST, payload);
export const employeeRatingSuccess = (payload: {
  employeeRating: EmployeeRatingInterface[];
}) => action(EmployeesTypes.EMPLOYEE_RATING_SUCCESS, payload);
export const employeeRatingFailure = () =>
  action(EmployeesTypes.EMPLOYEE_RATING_FALURE);
